import {gql} from "@apollo/client";

export const enableCardForCustomerMutation = gql`
    mutation($input: CustomerEnableCardFeatureInput) {
        customerEnableCardFeature: customerEnableCardFeature_Admin(input: $input) {
            id
        }
    }
`

export const deleteCardV2Mutation = gql`
  mutation DeleteCardV2_Admin($input: DeleteCardRequestV2_Admin!) {
    deleteCardV2_Admin(input: $input) { status }
  }
`